export enum AuthorityAccessory {
  REGISTER_ACCESSORY_EDIT = '1.20.4',
  REGISTER_ACCESSORY_DELETE = '1.20.3',
  REGISTER_ACCESSORY_ADD = '1.20.2',
  REGISTER_ACCESSORY_VIEW = '1.20.1',
  REGISTER_ACCESSORY_REGISTRATION = '1.20',
}
